import React from "react";

import { Flex, Modal, Typography } from "antd";
import i18next from "i18next";

import { OrderFailedIcon } from "svg";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const OrderInfoModal: React.FC<Props> = ({ isOpen, onClose }) => {
  return (
    <Modal
      open={isOpen}
      centered
      destroyOnHidden
      okButtonProps={{ style: { margin: 0, width: "100%" } }}
      cancelButtonProps={{ style: { display: "none" } }}
      onOk={onClose}
      onCancel={onClose}
      styles={{ body: { justifyContent: "center" } }}
    >
      <>
        <Flex justify="center">
          <OrderFailedIcon />
        </Flex>
        <Typography.Title level={3}>
          {i18next.t("order_has_failed")}
        </Typography.Title>
        <Typography.Text>
          {i18next.t("not_enough_availability")}
        </Typography.Text>
      </>
    </Modal>
  );
};
export default OrderInfoModal;
